'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _express = require('express');

var _minimajs = require('minimajs');

var _expressRemoveRoute = require('express-remove-route');

var _expressRemoveRoute2 = _interopRequireDefault(_expressRemoveRoute);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var webApiExtensionPoint = "minima.webapis";

var PluginRestServiceExtensionHandler = function () {
    /**
     * Creates an instance of PluginRestServiceExtensionHandler.
     * 
     * @param {Minima} minima
     * @param {Express} app 
     * @memberof PluginRestServiceExtensionHandler
     */
    function PluginRestServiceExtensionHandler(minima, app) {
        (0, _classCallCheck3.default)(this, PluginRestServiceExtensionHandler);

        this.minima = minima;
        this.app = app;

        /**
         * @type {Map.<Plugin, Set.<PluginRestServiceHandlerRegistry>>}
         */
        this.pluginRestServiceHandlers = new _map2.default();

        this.findHandler = this.findHandler.bind(this);
        this.handleWebApisExtensions = this.handleWebApisExtensions.bind(this);
        this.webApiExtensionChanged = this.webApiExtensionChanged.bind(this);
        this.addWebApiExtension = this.addWebApiExtension.bind(this);
        this.removeWebApiExtension = this.removeWebApiExtension.bind(this);

        var self = this;

        self.handleWebApisExtensions();
        minima.addExtensionChangedListener(this.webApiExtensionChanged);
    }

    (0, _createClass3.default)(PluginRestServiceExtensionHandler, [{
        key: 'handleWebApisExtensions',
        value: function handleWebApisExtensions() {
            var extensions = this.minima.getExtensions(webApiExtensionPoint);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(extensions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var extension = _step.value;

                    this.addWebApiExtension(extension);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        /**
         * @param {Extension} extension 
         * @param {ExtensionAction} action 
         * @memberof PluginRestServiceExtensionHandler
         */

    }, {
        key: 'webApiExtensionChanged',
        value: function webApiExtensionChanged(extension, action) {
            if (extension.id === webApiExtensionPoint) {
                if (action === _minimajs.ExtensionAction.ADDED) {
                    this.addWebApiExtension(extension);
                } else {
                    this.removeWebApiExtension(extension);
                }
            }
        }

        /**
         * @param {Extension} extension 
         * @memberof PluginRestServiceExtensionHandler
         */

    }, {
        key: 'addWebApiExtension',
        value: function addWebApiExtension(extension) {
            var plugin = extension.owner;
            var servicePath = extension.data.path;
            if (!servicePath) {
                throw new Error('The path of minima.webapis extension of ' + plugin.id + ' can not be empty.');
            }

            var handlerClass = extension.data.handler;
            if (!handlerClass) {
                throw new Error('The handler of minima.webapis extension of ' + plugin.id + ' can not be empty.');
            }

            var method = extension.data.method;
            if (!method) {
                method = PluginRestServiceHandlerRegistry.DEFAULT;
            }

            if (method !== PluginRestServiceHandlerRegistry.GET && method !== PluginRestServiceHandlerRegistry.POST && method !== PluginRestServiceHandlerRegistry.PUT && method !== PluginRestServiceHandlerRegistry.DELETE) {
                throw new Error('The method of minima.webapis extension of ' + plugin.id + ' must be get, post, put or delete.');
            }

            if (this.findHandler(plugin, servicePath, method)) {
                throw new Error('The minima.webapis extension of ' + plugin.id + ' can not be handled since duplicated path ' + servicePath + ', ' + method + ' in plugin ' + plugin.id + '.');
            }

            var Handler = extension.owner.loadClass(handlerClass);
            if (!Handler) {
                throw new Error('Can not load the class ' + handlerClass + ' from the minima.webapis extension of ' + plugin.id + '.');
            }

            if (!Handler.default) {
                throw new Error('The class ' + extension.data.handler + ' from the minima.webapis extension of ' + plugin.id + ' does not declare with \'default\'.');
            }

            var handlerInstance = new Handler.default(plugin);

            var pluginRequestHandler = new PluginRestServiceHandlerRegistry(this.app, plugin, servicePath, method, handlerInstance);
            if (!this.pluginRestServiceHandlers.has(plugin)) {
                this.pluginRestServiceHandlers.set(plugin, new _set2.default());
            }
            this.pluginRestServiceHandlers.get(plugin).add(pluginRequestHandler);
            pluginRequestHandler.register();
        }
    }, {
        key: 'findHandler',
        value: function findHandler(plugin, servicePath, method) {
            var handlers = this.pluginRestServiceHandlers.get(plugin);
            if (!handlers) {
                return null;
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(handlers), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var handler = _step2.value;

                    if (handler.servicePath === servicePath && handler.method === method) {
                        return handler;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return null;
        }

        /**
         * @param {Extension} extension 
         * @memberof PluginRestServiceExtensionHandler
         */

    }, {
        key: 'removeWebApiExtension',
        value: function removeWebApiExtension(extension) {
            var plugin = extension.owner;
            var servicePath = extension.data.path;
            var method = extension.data.method;

            if (!method) {
                method = PluginRestServiceHandlerRegistry.DEFAULT;
            }

            if (!this.pluginRestServiceHandlers.has(plugin)) {
                return;
            }

            var toBeRemovedHandler = this.findHandler(plugin, servicePath, method);
            if (!toBeRemovedHandler) {
                return;
            }

            toBeRemovedHandler.unregister();
            this.pluginRestServiceHandlers.get(plugin).delete(toBeRemovedHandler);
        }
    }]);
    return PluginRestServiceExtensionHandler;
}();

/**
 * Plugin + Path + Method is a REST service handler.
 * 
 * @class PluginRestServiceHandlerRegistry
 */


exports.default = PluginRestServiceExtensionHandler;

var PluginRestServiceHandlerRegistry = function () {
    /**
     * Creates an instance of PluginRestServiceHandlerRegistry.
     * 
     * @param {Express} app
     * @param {Plugin} plugin 
     * @param {string} servicePath 
     * @param {string} method 
     * @param {PluginRestServiceHandler} handler 
     * @memberof PluginRestServiceHandlerRegistry
     */
    function PluginRestServiceHandlerRegistry(app, plugin, servicePath, method, handler) {
        (0, _classCallCheck3.default)(this, PluginRestServiceHandlerRegistry);

        _minimajs.Assert.notNull("app", app);
        _minimajs.Assert.notNull("plugin", plugin);
        _minimajs.Assert.notEmpty("servicePath", servicePath);
        _minimajs.Assert.notNull("handler", handler);

        if (!method) {
            method = PluginRestServiceHandlerRegistry.DEFAULT;
        }

        this.app = app;
        this.plugin = plugin;
        this.servicePath = servicePath;
        this.handler = handler;
        this.method = method.toLowerCase();

        if (this.method !== PluginRestServiceHandlerRegistry.GET && this.method !== PluginRestServiceHandlerRegistry.POST && this.method !== PluginRestServiceHandlerRegistry.PUT && this.method !== PluginRestServiceHandlerRegistry.DELETE) {
            throw new Error("The method must be get, post, put or delete.");
        }

        this.register = this.register.bind(this);
        this.unregister = this.unregister.bind(this);
        this.handleRequest = this.handleRequest.bind(this);
    }

    (0, _createClass3.default)(PluginRestServiceHandlerRegistry, [{
        key: 'register',
        value: function register() {
            if (this.method === PluginRestServiceHandlerRegistry.GET) {
                this.app.get('/' + this.plugin.id + '/' + this.servicePath, this.handleRequest);
            } else if (this.method === PluginRestServiceHandlerRegistry.POST) {
                this.app.post('/' + this.plugin.id + '/' + this.servicePath, this.handleRequest);
            } else if (this.method === PluginRestServiceHandlerRegistry.PUT) {
                this.app.put('/' + this.plugin.id + '/' + this.servicePath, this.handleRequest);
            } else if (this.method === PluginRestServiceHandlerRegistry.DELETE) {
                this.app.delete('/' + this.plugin.id + '/' + this.servicePath, this.handleRequest);
            }
        }
    }, {
        key: 'unregister',
        value: function unregister() {
            (0, _expressRemoveRoute2.default)(this.app, this.servicePath, this.method);
            this.app = null;
            this.handler = null;
            this.plugin = null;
            this.method = null;
        }
    }, {
        key: 'handleRequest',
        value: function handleRequest(request, response) {
            if (this.plugin.state === _minimajs.PluginState.ACTIVE) {
                this.handler.handle(request, response);
            } else {
                throw new Error('Can not handle the /' + this.plugin.id + '/' + this.servicePath + ' request since the plugin is not active.');
            }
        }
    }]);
    return PluginRestServiceHandlerRegistry;
}();

PluginRestServiceHandlerRegistry.DEFAULT = "get";
PluginRestServiceHandlerRegistry.GET = "get";
PluginRestServiceHandlerRegistry.POST = "post";
PluginRestServiceHandlerRegistry.PUT = "put";
PluginRestServiceHandlerRegistry.DELETE = "delete";
//# sourceMappingURL=PluginRestServiceExtensionHandler.js.map